import { caption } from '../../styles/commonStyles';
import { Box, Stack, SxProps } from '@mui/material';

export interface IPendingTagsInfoProps {
	pendingTagsCount?: number;
	updatedTagsCount?: number;
	removedTagsCount?: number;
	assignedTagsCount?: number;
	textSx?: SxProps;
	unassignedTagsMessage?: string;
	assignedTagsMessage?: string;
}

const PendingTagsInfo: React.FunctionComponent<IPendingTagsInfoProps> = props => {
	const textSx = props.textSx ?? caption;

	return (
		<Stack direction="row" flexWrap="wrap" gap={1} paddingX={2} data-test-id="pending-tags-info">
			{props.pendingTagsCount > 0 && (
				<Box sx={textSx} data-test-id="added-tags-info">
					{`${localize(props.assignedTagsMessage || '{0} tag(s) will be added', props.pendingTagsCount)}${
						props.updatedTagsCount > 0 || props.removedTagsCount > 0 ? ',' : ''
					}`}
				</Box>
			)}
			{props.updatedTagsCount > 0 && (
				<Box sx={textSx} data-test-id="updated-tags-info">
					{`${localize('{0} tag(s) will be renamed', props.updatedTagsCount)}${
						props.removedTagsCount > 0 ? ',' : ''
					}`}
				</Box>
			)}
			{props.removedTagsCount > 0 && (
				<Box sx={textSx} data-test-id="removed-tags-info">
					{localize(props.unassignedTagsMessage || '{0} tag(s) will be deleted', props.removedTagsCount)}
				</Box>
			)}
			{props.assignedTagsCount > 0 && (
				<Box sx={textSx} data-test-id="assigned-tags-info">
					{localize('{0} tag(s) will be assigned', props.assignedTagsCount)}
				</Box>
			)}
		</Stack>
	);
};

export default PendingTagsInfo;
